export default __webpack_public_path__ + "static/media/sports5.eeaba01a.jpg";